var createName = function createName(name) {
  return "@@redux-saga/" + name;
};

var createSymbol = function createSymbol(id) {
  id = createName(id);
  return typeof Symbol === 'function' ? Symbol(id) : id;
};

var createGlobalSymbol = function createGlobalSymbol(id) {
  id = createName(id);
  return typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for(id) : id;
};

export var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
export var CHANNEL_END =
/*#__PURE__*/
createSymbol('CHANNEL_END');
export var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
export var IO =
/*#__PURE__*/
createSymbol('IO');
export var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
export var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
export var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
export var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
export var TASK =
/*#__PURE__*/
createSymbol('TASK');
export var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
export var SAGA_LOCATION =
/*#__PURE__*/
createGlobalSymbol('LOCATION');